"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
import ReactDOM from "react-dom";
import ExceptionSenderWrapper from "../exception_sender_wrapper";
const FACTOR_INVOICE_ID_ATTR = "factor-invoice-id";
const EMAIL_ID_ATTR = "email-id";
const TAG = "ht-exception-sender";
class ExceptionSenderElement extends HTMLElement {
  constructor() {
    super(...arguments);
    __publicField(this, "queuedMessages", []);
  }
  static get observedAttributes() {
    return [FACTOR_INVOICE_ID_ATTR, EMAIL_ID_ATTR];
  }
  connectedCallback() {
    this.renderFromAttributes();
  }
  attributeChangedCallback(name) {
    if (name === FACTOR_INVOICE_ID_ATTR || name === EMAIL_ID_ATTR) {
      this.renderFromAttributes();
    }
  }
  disconnectedCallback() {
    ReactDOM.unmountComponentAtNode(this);
  }
  renderFromAttributes() {
    const factorInvoiceId = this.getAttribute(FACTOR_INVOICE_ID_ATTR);
    if (!factorInvoiceId) return;
    const emailId = this.getAttribute(EMAIL_ID_ATTR);
    ReactDOM.render(
      React.createElement(ExceptionSenderWrapper, {
        factorInvoiceId: parseInt(factorInvoiceId, 10),
        emailId: emailId ? parseInt(emailId, 10) : void 0,
        queuedMessages: this.queuedMessages || [],
        onComplete: () => {
          this.dispatchEvent(
            new CustomEvent("exception-sent", { bubbles: true })
          );
        },
        onCancel: () => {
          this.dispatchEvent(
            new CustomEvent("exception-cancelled", { bubbles: true })
          );
        }
      }),
      this
    );
  }
}
if (!customElements.get(TAG)) {
  customElements.define(TAG, ExceptionSenderElement);
}
